import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import { buttonsAvailable } from 'layouts/PruffConnect/SideBar/buttonsAvailable';
import { getAssignatedExecutives } from 'lib/api/express';
import CustomButton from 'lib/designSystem/Button';
import TableCard from 'lib/designSystem/Card/TableCard';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import IconWrapper from 'lib/designSystem/IconWrapper';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'services/redux/store';

const PruffConnectHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const domain = window.location.hostname;
  const secretId = domain.split('.')[0];
  const auth = useSelector((state: RootState) => state.auth);
  const businessIdentifier = auth.user?.businessIdentifier;
  const { data, isPending } = getAssignatedExecutives(
    dispatch,
    secretId,
    businessIdentifier,
  );
  const clientCompanyTypes = useSelector(
    (state: RootState) => state.clientCompanyTypes,
  );
  const user = auth.user;
  const handleProductClick = (id: string) => {
    navigate(`/${id}`);
  };

  const executiveName = data?.[0]?.name ?? '-';
  const executivePhone = data?.[0]?.phone ?? '-';
  const executiveEmail = data?.[0]?.email ?? '-';

  const getAvailableProducts = () => {
    const products = [];
    const availableTypes = clientCompanyTypes?.types?.map(
      (type) => type.typeId,
    );
    if (availableTypes?.includes('factoring')) {
      products.push({
        id: 'factoring',
        name: buttonsAvailable.factoring.label,
        description:
          'Accede a liquidez inmediata para respaldar la operación de tu empresa mediante factoring.',
        path: buttonsAvailable.factoring.id,
        icon: buttonsAvailable.factoring.icon,
      });
    }
    if (availableTypes?.includes('sgr')) {
      products.push({
        id: 'sgr',
        name: buttonsAvailable.sgr.label,
        description:
          'Accede al respaldo que necesitas en licitaciones públicas y privadas',
        path: buttonsAvailable.sgr.id,
        icon: buttonsAvailable.sgr.icon,
      });
    }
    if (availableTypes?.includes('credit')) {
      products.push({
        id: 'credit',
        name: buttonsAvailable.credit.label,
        description:
          'Accede al financiamiento que necesitas para respaldar y hacer crecer tu negocio.',
        path: buttonsAvailable.credit.id,
        icon: buttonsAvailable.credit.icon,
      });
    }
    return products;
  };

  if (isPending) return <CenteredCircularProgress />;

  return (
    <Box py={3}>
      <TableCard>
        <Stack direction="column" spacing={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <IconWrapper>
              <AccountCircleIcon fontSize="large" />
            </IconWrapper>
            <Typography variant="h4" gutterBottom>
              ¡Hola {user?.name}!
            </Typography>
          </Stack>
          <Typography variant="body1">
            Iniciaste sesión con la empresa:{' '}
            <strong>{user?.companyName}</strong>
          </Typography>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack direction="row" spacing={4}>
          <Typography variant="body1">
            Tu ejecutivo es: <strong>{executiveName}</strong>
          </Typography>
          <Typography variant="body1">
            Télefono: <strong>{executivePhone}</strong>
          </Typography>
          <Typography variant="body1">
            Email: <strong>{executiveEmail}</strong>
          </Typography>
        </Stack>
      </TableCard>

      <Stack direction="column" spacing={2} my={4}>
        <Typography variant="h4">¿Que necesitas hacer hoy?</Typography>
        <Typography variant="body1">
          Desde aquí puedes activar tus productos, contratar nuevos servicios y
          acceder directamente a las plataformas de tus productos.
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        {getAvailableProducts().map((product) => (
          <Grid item xs={12} md={4} key={product.id}>
            <TableCard key={product.id}>
              <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                <IconWrapper>{product.icon}</IconWrapper>
                <Typography variant="h5">{product.name}</Typography>
              </Stack>
              <Typography variant="body1" mb={2}>
                {product.description}
              </Typography>
              <CustomButton
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  handleProductClick(product.path);
                }}
              >
                Acceder
              </CustomButton>
            </TableCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PruffConnectHome;
